<template>
    <div>
        <div class="dh_p1a w-100">
            <div class="x_div_center" style="height:100%; background-color:rgba(0, 0, 0, 0.3);">
                <div class="rp_set px-3" style="padding:120px 0 0 0;">
                    <span class="dh_p1b">About M3</span><br>
                    <span class="dh_p1c">ESG (Environmental, Social and Governance) as the core of corporate management,<br>pursuing customer value rather than price. With its own platform equipped with integrated BIM and DfMA core technology,<br>Implementation of buildings more conveniently and quickly.</span>
                </div>
            </div>
        </div>

        <div class="x_div_center">
            <div class="rp_set" style="border:0px solid red">

                <!-- (주)엠쓰리시스템즈 -->
                <div class="iw-1 py-3 pt-5">
                    <div class="iw-2"><img src="@/assets/img/s_info/info1.png" width="100%"></div>
                    <div class="iw-4 px-4">
                        <div class="py-4"><img src="@/assets/img/s_info/s_info_logo.png" width="250"></div>
                        <div style="line-height:200%">
                            <p class="fkr-set2 fs-13 fc-w10"><strong>M3systems Co., Ltd.</strong></p>
                            <p class="fkr-set2 fs-09"><strong>Manufactured Modular via Meta-X Systems.</strong></p>
                            <p class="fkr-set2 fs-09">M3 is a modular architecture integrated platform service company with advanced BIM integrated DfMA technology.</p>
                            <p class="fkr-set2 fs-09">Based on ESG (Environmental, Social and Governance) corporate management ethics, we provide fast, accurate, and convenient architectural spaces with professionals.</p>
                            <p class="fkr-set2 fs-09">With the researchers' experience and expertise in BIM R&D over the past 20 years, we will grow into a reliable company that makes premium modular buildings.</p>
                        </div>
                    </div>
                </div>

                <div style="height:50px"></div>

                <!-- Characteristics -->
                <div class="py-3">
                    <div class="x_div_center"><span class="fen-set3 fs-16"><strong><h2>Characteristics</h2></strong></span></div>
                    <div class="x_div_center py-3"><span class="fkr-set2 fs-10">The M3 leads with speed, quality, technology, and eco-friendly architecture.</span></div>
                    <div class="iw-1">
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info2.jpg" width="95%"></div>
                                <div class="text-center py-2"><div class="py-2 fen-set3 fs-13"><h5>Speed</h5></div><div class="px-3 fkr-set2 fs-09">Optimized design that meets customer preferences and requirements and realize it quickly.</div></div>
                            </div>
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info3.png" width="95%"></div>
                                <div class="text-center py-2"><div class="py-2 fen-set3 fs-13"><h5>Higher Quality</h5></div><div class="px-3 fkr-set2 fs-09">Through digitization and manufacturing, we provide price, value, and high-quality buildings quickly.</div></div>
                            </div>
                        </div>
                        <div class="iw-3 d-flex" style="align-items:start;">
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info4.jpg" width="95%"></div>
                                <div class="text-center py-2"><div class="py-2 fen-set3 fs-13"><h5>BIM + Platform</h5></div><div class="px-3 fkr-set2 fs-09">We provide fast and high-quality architectural services with accumulated BIM technology and DfMA platform.</div></div>
                            </div>
                            <div class="iw-3 px-1 py-2">
                                <div class="text-center"><img src="@/assets/img/s_info/info5.jpg" width="95%"></div>
                                <div class="text-center py-2"><div class="py-2 fen-set3 fs-13"><h5>Eco-Friendly</h5></div><div class="px-3 fkr-set2 fs-09">Modular construction reduces waste materials and the eco-friendly design effectively reduces cooling and heating costs.</div></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="height:50px"></div>


                <div class="py-3" style="border-bottom:1px solid #e9e9e9; overflow-x:auto">
                    <div class="x_div_center"><span class="fen-set3 fs-16"><strong><h2>Facilities</h2></strong></span></div>
                    <div class="x_div_center py-3"><span class="fkr-set2 fs-10">A place to create your dreams and future</span></div>
                    <div class="iw-1">
                        <div class="iw-5 px-3 py-2">
                            <div class="w-100" data-toggle="modal" data-target="#v-s1"><img src="@/assets/img/s_info/s_info_m1.jpg" width="100%" height="250"><div class="x_div_center py-2 fkr-set1 fs-10">Headquarter</div></div>
                        </div>
                        <div class="iw-5 px-3 py-2">
                            <div class="w-100" data-toggle="modal" data-target="#v-s2"><img src="@/assets/img/s_info/s_info_m2.png" width="100%" height="250"><div class="x_div_center py-2 fkr-set1 fs-10">Affilated research lab</div></div>
                        </div>
                        <div class="iw-5 px-3 py-2">
                            <div class="w-100" data-toggle="modal" data-target="#v-s3"><img src="@/assets/img/s_info/s_info_m3.jpg" width="100%" height="250"><div class="x_div_center py-2 fkr-set1 fs-10">Modules Manufacturing Facility</div></div>
                        </div>
                    </div>
                </div>

                <!-- 본사 -->
                <div id="v-s1" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100" style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">Headquarter</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <div><img src="@/assets/img/s_info/s_info_m1.jpg" width="100%" style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- 부설연구소 -->
                <div id="v-s2" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100" style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">Affilated research lab</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <div><img src="@/assets/img/s_info/s_info_m2.png" width="100%" style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- 모듈러 공장 -->
                <div id="v-s3" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="z-index:100000001; top:7%">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">

                            <div class="w-100">
                                <div class="x_div_center w-100" style="background-color:#333; border-top-left-radius:4px; border-top-right-radius:4px">
                                    <div class="w-100 p-3 ps-4"><span class="fkr-set1 fs-11 fc-w8">Modules Manufacturing Facility</span></div>
                                    <div class="text-end pe-4" style="width:100px"><a href="#@" data-dismiss="modal"><i class="fa-solid fa-xmark fs-15 fc-w1"></i></a></div>
                                </div>

                                <div><img src="@/assets/img/s_info/s_info_m3.jpg" width="100%" style="border-bottom-left-radius:5px; border-bottom-right-radius:5px"></div>

                            </div>

                        </div>
                    </div>
                </div>
                <MenuFooter/>
            </div>
        </div>
    </div>
</template>

<script>
import MenuFooter from '@/components/MenuFooterEn.vue'
export default {
    name: 'MenuIntroduction',
    components: {
        MenuFooter
    }
}
</script>